import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import {
	openMainMenu,
	setMainMenuItems,
	setTsqWindow,
} from '../actions/mainMenu';

/**
 * メインメニューのState型
 */
export interface IMainMenuState {
	readonly open: boolean;
	readonly permittedItems: string[];
	readonly tsqWindow: Window | null;
}

/**
 * メインメニューのState初期値
 */
const initialState: IMainMenuState = {
	open: false,
	permittedItems: [],
	tsqWindow: null,
};

/**
 * メインメニュー用reducer
 * @param state State
 * @param action アクション
 */
const mainMenu = (state: IMainMenuState, action: Action) => {
	if (!state) {
		// State初期化処理
		state = initialState;
		state = initializeState(state);
	}
	if (isType(action, openMainMenu)) {
		return {
			...state,
			open: action.payload.isOpen,
		};
	}

	if (isType(action, setMainMenuItems)) {
		return {
			...state,
			permittedItems: action.payload.items,
		};
	}

	if (isType(action, setTsqWindow)) {
		return {
			...state,
			tsqWindow: action.payload.tsqWindow,
		};
	}

	return state;
};

export default mainMenu;



// WEBPACK FOOTER //
// ./src/reducers/mainMenu.ts